import { Col, Row, Modal, Form, Input, Select, message } from "antd";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { UseMutateAsyncFunction, useMutation, useQuery } from "react-query";
import { AxiosResponse } from "axios";

import Title from "../../../UI/Title/Title";
import AddEditModal from "../../../UI/ModalComponent/AddEditModal/addeditcomponent";
import InputName from "../../../UI/InputNumberComponent/InputName";
import { getCountriesDropdown } from "../../../../api/countries";
import { createCustomer } from "../../../../api/customers";
import { customerType } from "../../../Customers/CustomerType";
import { getCurrencyById } from "../../../../api/setting";
import { validateEmail, validateFullName, validatePhoneNumber } from "../../../../utils/validatorsRules";

type propsType = {
  openCustomer: boolean;
  setOpenCustomer: React.Dispatch<React.SetStateAction<boolean>>;
  search: string;
  page: number;
  getCutomersMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
    },
    unknown
  >;
  setCustomers: Dispatch<SetStateAction<any>>;
};

export const AddCustomer = ({
  openCustomer,
  setOpenCustomer,
  search,
  page,
  getCutomersMutation,
  setCustomers,
}: propsType) => {
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);

  const [form] = Form.useForm();
  const [fullName, setFullName] = useState<any>(null);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState<null>(null);
  const [formatedCountries, setFormatedCountries] = useState<{}[]>();

  const [formatedCountry, setFormatedCountry] = useState<{}[]>();
  useQuery("countries", getCountriesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res: any) => {
      const formattedCountryData = res.data?.map((country: any) => {
        return {
          value: country.areaCode,
          label: (
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img style={{ width: 15, height: 15, marginRight: '0.3rem' }} src={`/flags/${country.abbreviation}.svg`} />
                {country.areaCode}
              </div>
            </>
          ),
        };
      });
      const uniqueFormattedCountryData = Array.from(
        new Set(formattedCountryData.map((country: any) => country.value))
      ).map((areaCode) =>
        formattedCountryData.find((country: any) => country.value === areaCode)
      );

      setFormatedCountry(uniqueFormattedCountryData);
    },
  });

  const filterOption = (inputValue: string, option: any) => {
    // Extract the text content from the JSX label
    const label = option?.label?.props?.children;
    if (label) {
      const normalizedInput = inputValue.toLowerCase().trim();
      const normalizedLabel = label.toString().toLowerCase();
      return normalizedLabel.includes(normalizedInput);
    }
    return true;
  };

  const selectphoneNumber = (
    <Form.Item noStyle name="areaCodeId" initialValue={"+961"}>
      <Select
        showSearch={true}
        filterOption={filterOption}
        style={{ width: 100 }}
        options={formatedCountry}
      />
    </Form.Item>
  );
  const { isLoading: loadingCountries } = useQuery(
    "getCountriesDropdown",
    getCountriesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: handleCountriesSuccess,
    }
  );

  function handleCountriesSuccess(res: any) {
    const formattedCountries = formatCountries(res.data);

    setFormatedCountries(formattedCountries);

    const lebanon = formattedCountries.find(
      (country: any) => country.label === "Lebanon"
    );

    if (lebanon) setSelectedCountry(lebanon);
  }

  function formatCountries(data: any) {
    return (data || []).reduce((formatted: any, country: any) => {
      if (country.isActive) {
        formatted.push({ value: country.id, label: country.name });
      }
      return formatted;
    }, []);
  }


  const [, setError] = useState<any>();

  const onError = (error: any, variables: customerType, context: unknown) => {
    let errorMessage = "An error occurred";

    if (error.response?.data?.errors?.[0]?.msg) {
      const errorData = error.response.data.errors[0];
      errorMessage = `${errorData.param} ${errorData.msg}`;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }

    if (setError) {
      setError(errorMessage);
    }

    message.error({
      content: errorMessage,
      duration: 10,
      onClick: () => {
        message.destroy();
      },
    });
  };

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    "createCustomr",
    (customer: customerType) => createCustomer(customer),
    {
      onSuccess: (res) => {
        setOpen(false);
        setOpenCustomer(false);
        getCutomersMutation({ limit: page * 5 + 5, q: search }).then((res) => {
          setCustomers(res.data.data);
        });
        form.resetFields();
        message.success("Complete successfully");
      },
      onError,
    }
  );
  const handleFinish = async () => {
    const newcustomer = form.getFieldsValue();
    for (const key in newcustomer) {
      if (newcustomer[key] === undefined) {
        newcustomer[key] = null;
      } else if (
        typeof newcustomer[key] === "string" &&
        newcustomer[key].trim() === ""
      ) {
        newcustomer[key] = null;
      }
    }

    const currencyResponse = await getCurrencyById();
    const settingCurrency = currencyResponse.data;
    newcustomer.curId = settingCurrency.id;
    newcustomer.isActive = true;
    const currentDate = new Date();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const day = currentDate.getDate().toString().padStart(2, "0");
    const year = currentDate.getFullYear().toString();
    const formattedDate = `${month}/${day}/${year}`;
    newcustomer.typeId = 1;
    newcustomer.phone = `${newcustomer.areaCodeId}/${newcustomer.phone}`;
    mutateCreateUpdate(newcustomer);
  };

  const handleCancel = () => {
    form.resetFields();
  };

  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={500}
        onCancel={() => {
          setOpenCustomer(false);
          setPhoneNumber(null);
          setFullName(null);
          handleCancel();
        }}
        open={openCustomer}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            background: !fullName || !phoneNumber || !selectedCountry ? "gray" : "#1677FF",
            color: "#fff",
            width: "100px",
          },
          disabled: !fullName || !phoneNumber || !selectedCountry,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={`${t("add")}`}
        onOk={() => {
          setOpen(true);
        }}
      >
        <Title title={`${t("add-customer")}`} />
        <Form
          layout="vertical"
          form={form}
          id="customerForm"
          onFinish={handleFinish}
        >
          <Row style={{ marginTop: "20px" }}>
            <Col span={16}>
              <Form.Item
                name="name"
                label={`${t("fullname")}`}
                rules={[
                  {
                    required: true,
                    message: `${t('this-field-is-required')}`
                  },
                  validateFullName
                ]}
              >
                <InputName
                  maxLength={50}
                  onChange={(value: any) => setFullName(value)}
                />
              </Form.Item>

              <Form.Item name="email" label={`${t("email")}`}
                rules={[
                  {
                    required: false,
                    message: `${t("please-enter-email")}`,
                  },
                  validateEmail,
                ]}
              >
                <InputName
                  maxLength={50}
                  autoComplete="off"
                  placeholder={`${t("enter-email")}`}
                />
              </Form.Item>

              <Form.Item
                label={`${t("country")}`}
                name="countryId"
                initialValue={selectedCountry?.value}
              >
                <Select
                  showSearch={true}
                  optionFilterProp="label"
                  onChange={(value: any) => setSelectedCountry(value)}
                  placeholder={`${t("select-country")}`}
                  options={formatedCountries}
                  loading={loadingCountries}
                />
              </Form.Item>

              <Form.Item label={`${t("primary-number")}`} name="phone"
                rules={[
                  {
                    required: true,
                    message: `${t('this-field-is-required')}`
                  },
                  validatePhoneNumber
                ]}>
                <Input
                  maxLength={20}
                  addonBefore={selectphoneNumber}
                  autoComplete="off"
                  style={{ width: "100%" }}
                  onChange={(e: any) => setPhoneNumber(e.target.value)}
                />
              </Form.Item>

              <Form.Item name="city" label={`${t("city")}`}>
                <InputName maxLength={50} />
              </Form.Item>

              <Form.Item label={`${t("address")}`} name="addressLine1">
                <InputName maxLength={50} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <AddEditModal
        form="customerForm"
        open={open}
        setOpen={setOpen}
        name={<span>{""}</span>}
        title={`${t("modal-customer")}`}
        isSaving={isSaving}
      />
    </>
  );
};
